import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useNS7Images = () => {
  // Fetch banner image
  const { data: bannerImage } = useQuery({
    queryKey: ["images", "ns7-banner"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "ns7-banner")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching NS7 banner image:", error);
        return null;
      }
      return data;
    },
  });

  // Fetch video image
  const { data: videoImage } = useQuery({
    queryKey: ["images", "ns7-video"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "ns7-video")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching NS7 video image:", error);
        return null;
      }
      return data;
    },
  });

  // Fetch info image
  const { data: infoImage } = useQuery({
    queryKey: ["images", "ns7-info"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "ns7-info")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching NS7 info image:", error);
        return null;
      }
      return data;
    },
  });

  // Helper function to get image URLs
  const getImageUrl = (image: any) => {
    if (image?.storage_path) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(image.storage_path);
      return data.publicUrl;
    }
    return null;
  };

  // Fallback images
  const fallbackImages = {
    banner: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e',
    video: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4', 
    info: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e'
  };

  return {
    bannerImageUrl: getImageUrl(bannerImage) || fallbackImages.banner,
    videoImageUrl: getImageUrl(videoImage) || fallbackImages.video,
    infoImageUrl: getImageUrl(infoImage) || fallbackImages.info
  };
};